// Centralized services data for both Services and Bookings pages
export const facials = [
  {
    id: "facial-1",
    name: "COMPLEXION REVIVAL FACIAL",
    price: "₦90,000",
    duration: "60/90 minutes",
    category: "facial",
    description:
      "Experience the pinnacle of skin rejuvenation with our complexion revival facial. This advanced treatment employs a unique, multi-step process that seamlessly integrates deep cleansing (hydro-derm), exfoliation, and hydration to unveil a smoother, more radiant complexion.",
  },
  {
    id: "facial-2",
    name: "THE SCULPT AND GLOW FACIAL",
    price: "₦90,000",
    duration: "60/90 minutes",
    category: "facial",
    description:
      "Indulge in our customized facial, which includes microcurrent, jade tools, lymphatic massage, and ice rollers. It detoxifies, decongests, brightens, and tones the face. You'll notice an immediate improvement in your skin's appearance and feel relaxed and stress-free.",
  },
  {
    id: "facial-3",
    name: "VELVET SKIN THERAPY",
    price: "₦90,000",
    duration: "60/90 minutes",
    category: "facial",
    description:
      "A non-invasive procedure that exfoliates (micro-derm) the skin, revealing a smoother, more youthful complexion. Our skilled estheticians tailor the treatment to your skin concerns for optimal results. After exfoliation, enjoy a soothing, hydrating mask that replenishes moisture, calms irritation, and enhances skin luminosity.",
  },
  {
    id: "facial-4",
    name: "GLOW GETTER PEEL",
    price: "₦80,000",
    duration: "60/90 minutes",
    category: "facial",
    description:
      "Emerald Peel, a gentle exfoliation treatment, targets fine lines, wrinkles, hyperpigmentation, and improves skin circulation with alpha hydroxy acids and minerals. It removes dead skin cells and brightens the complexion. We also offer an emerald cooling mask, cooling globes, a rejuvenating facial massage, and a nourishing mask to soothe the face.",
  },
  {
    id: "facial-5",
    name: "ULTIMATE LUXE FACIAL",
    price: "₦150,000",
    duration: "60/90 minutes",
    category: "facial",
    description:
      "A full-on pampering session that rejuvenates and revitalizes.",
    features: [
      "Begins with a soothing deep-pressure point massage to loosen face and neck muscles.",
      "Hydro or microderm machine gently removes dead skin cells to brighten the complexion.",
      "Oxygen foam deep cleanser mask for a thorough cleanse.",
      "24k Gold serum infused into the skin using our infusing machine.",
      "Soothing face and neck massage to relieve stress.",
      "Hydrating face cream to restore and nourish the skin.",
      "Relaxing feet and hand massage.",
    ],
  },
];

export const massages = [
  {
    id: "massage-1",
    name: "IT'S NOT THAT DEEP MASSAGE",
    price: "₦80,000",
    duration: "60/120 minutes",
    category: "massage",
    description:
      "A powerful full-body massage to relieve aching, tight muscles. Thumb and palm pressure (with optional elbows for deeper pressure) loosens stiffness. Special aroma oil helps stretch and break tensely knotted muscles, energizing the body and improving blood circulation. Rejuvenates and refreshes.",
  },
  {
    id: "massage-2",
    name: "POST WORKOUT MASSAGE",
    price: "₦80,000",
    duration: "60/120 minutes",
    category: "massage",
    description:
      "Perfect after exertion or when you've skipped your stretches. Starts with a 15-minute stretch to relieve stiffness, followed by a deep-tissue massage targeting sore muscles. Leaves you relaxed, rejuvenated, and ready to return to your routine.",
  },
  {
    id: "massage-3",
    name: "STRETCH ME OUT MASSAGE",
    price: "₦80,000",
    duration: "60/120 minutes",
    category: "massage",
    description:
      "An intimate, hands-on session including pulling, stretching, and rocking the body. Therapists use hands, feet, and knees to apply pressure, stretch, and manipulate the body. Yoga-style stretches target tight muscles; session concludes with a relaxing body massage to calm mind and body.",
  },
  {
    id: "massage-4",
    name: "STONE ME MASSAGE",
    price: "₦80,000",
    duration: "60/120 minutes",
    category: "massage",
    description:
      "Tailored hot-stone massage to unravel persistent muscular tightness. Aromatic essential oils relieve stress and recharge your spirit. Heated stones rest on trigger points and penetrate body tissues to improve circulation and leave you rejuvenated from head to toe.",
  },
  {
    id: "massage-5",
    name: "HAPPY HANDS AND FEET MASSAGE",
    price: "₦50,000",
    duration: "60/120 minutes",
    category: "massage",
    description:
      "Targeted hands-and-feet treatment to relieve tension and daily stress through tension-point massage. Promotes relaxation, reduces pain, and improves blood flow. Aroma oils help release built-up stress—ideal for those on their feet all day or with overworked hands and feet.",
  },
];

export const packages = [
  {
    id: "package-1",
    name: "I WANT IT ALL PACKAGE",
    price: "₦200,000",
    duration: "2 hours",
    category: "package",
    description:
      "Experience ultimate self-care with our Deluxe Spa Package. Choose two coveted treatments: Luxe Facial and Luxe Massage.",
    flow: "Begin with a deeply restorative Luxe Massage, then drift into a skin-reviving Luxe Facial using premium products and expert techniques.",
    includes: [
      "Signature Luxe Full-Body Massage",
      "Luxe Facial",
      "Warm towel ritual",
      "Finishing glow elixir",
      "Free body fragrance",
    ],
  },
];

// Combine all services for easy lookup
export const allServices = [...facials, ...massages, ...packages];

// Helper function to find service by name
export const findServiceByName = (name) => {
  return allServices.find(
    (service) => service.name.toLowerCase() === name.toLowerCase()
  );
};

// Helper function to get services by category
export const getServicesByCategory = (category) => {
  return allServices.filter((service) => service.category === category);
};

